import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {
  displayContentJsonSchema,
  displayContentUiLayeredSchema,
  displayContentUiMainSchema,
} from '@/services/schema//displayContentSchema'
import {SALES_TARGET_MAIN_GROUP} from '@/utils/constants/globalConstants'

const DisplayContentTab = props => {
  const {setDisplayContentFormData, displayContentFormData, activeLanguage, languages, targetType} = props
  const handleChange = data => {
    setDisplayContentFormData(prevData => ({...prevData, [activeLanguage]: data}))
  }

  const getDisplayContentUiSchema = () => {
    if (SALES_TARGET_MAIN_GROUP.indexOf(targetType) > -1) {
      return displayContentUiMainSchema
    }
    return displayContentUiLayeredSchema
  }
  return (
    <div data-testid="displayContentForm">
      {languages &&
        languages.length > 0 &&
        languages.map(
          lang =>
            lang.code === activeLanguage && (
              <JsonFormsWrapper
                key={`${lang?.code}`}
                jsonschema={displayContentJsonSchema}
                uischema={getDisplayContentUiSchema()}
                data={displayContentFormData[activeLanguage]}
                onChange={handleChange}
                // Updating form data on change
              />
            )
        )}
    </div>
  )
}

export default DisplayContentTab
